
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import AlertModule from 'vux/src/plugins/alert/module'
import Alert from 'vux/src/components/alert/index.vue'

import global from '../../../static/js/global.js'
import loadPage from '../../components/loadingPage'
import $ from 'jquery'
export default {
components: {
XHeader,
Group,
PopupRadio,
XInput,
XTextarea,
Cell,
XButton,
PopupPicker,
Alert,
loadPage,
$
},
directives: {
TransferDom
},
data(){
return{
districtlist:[[]],
districtlistid:[],
district:[' '],
houselist:[[],[],[]],
houselistn:[],
houselistid:[],
house:[' ',' ',' '],
buildid:[],
relation:['本人'],
relationlist:[[]],
relationlistid:[],
owner:'',
messageWarn:'',
username:'',
phone:'',
houseBind:'',
alertTitle:'',
alertContent:'',
showAlert:false,
readonlyable:true,
buildList:[]
}
},
beforeMount(){
this.show_1 = true;
/*获取所有小区*/
this.$http.get(global.host + 'community/getList').then(function(res){
if(res.body){
let datacommunity = res.body.result;
let list = [];let listid = [];
for(let i = 0 ;i < datacommunity.length ; i++){
this.districtlist[0].push(datacommunity[i].comnName)
this.districtlistid.push(datacommunity[i].comnCode)
}

}
this.show_1 = false;
},function(err){
console.log(err)
}),
/*获取与业主的关系*/
this.$http.get(global.host + '/dict/getDiceByTypeEqHousereLation',).then(function(res){
if(res.body.result){
let data = res.body.result;
for(let i = 0 ;i < data.length; i++){
this.relationlist[0].push(data[i].label)
this.relationlistid.push(data[i].id)
}
}
},function(err){
console.log(err);
})
},
mounted(){
let mobile = this.$router.history.current.query.phone;
this.phone = mobile.substring(0,3) + '****' + mobile.substring(7,11);
if(this.$router.history.current.path == "/houseBind"){
document.title = "业主认证";
}
},
methods:{
onHide(){
this.showAlert = false;
if(this.alertContent == '房屋绑定成功'){
if(this.$router.history.current.query.muId == 3){
this.$router.push({path:'/pay/tenement',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}})
}else if(this.$router.history.current.query.muId == 4){
this.$router.push({path:'/',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}})
}else{
this.$router.push({path:'/user',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}})
}
}
},
beforXy(mrquerUrl){

let objectInfo = new Object();
objectInfo.comnCode = this.districtlistid[this.getIndex(this.districtlist[0],this.district[0])];
objectInfo.hsNo = this.house[2];
objectInfo.hsName = this.owner;
objectInfo.phoneModel = navigator.userAgent;
objectInfo.requestUrl = mrquerUrl;

let newUrl = global.host + 'sys/addSystemLog';
this.$http.post(newUrl,objectInfo).then(function(res){
console.log(res.body.result)
},function(err){
console.log(err)
})
},
/*房间绑定验证*/
bindHouse(){

this.owner = this.owner.replace(/(^\s*)|(\s*$)/g,"");
this.$http.get(global.host + '/users/checkUserIsExistByUtil?comnCode='+ this.districtlistid[this.getIndex(this.districtlist[0],this.district[0])] + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0],this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' +  this.house[2] + '&userName=' + encodeURIComponent(this.owner),).then(function(res){
if(res.body.success){
/*改变样式 存在*/
this.houseBind = true;
this.bindHouseSubmit();
}else{
/*改变样式 不存在*/
this.alertTitle ='温馨提示'
this.alertContent = '请输入物业登记的业主姓名'
this.houseBind = false;
this.showAlert = true;
setTimeout(function(){this.showAlert = false;},2000)
}
},function(err){
console.log(err);
})
},
/*房间绑定提交*/
bindHouseSubmit(){
var regRule = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
if(this.district[0] == ' ' || !this.district[0]){
this.messageWarn = '温馨提示：请选择小区'
}else if((!this.house[0] || this.house[0] == ' ') && (!this.house[1] || this.house[1] == ' ') && (!this.house[2] || this.house[2] == ' ') ){
this.messageWarn = '温馨提示：请选择房间'
}else if(!this.owner){
this.messageWarn = '温馨提示：请输入业主姓名'
}else if(this.owner.match(regRule)) {
this.messageWarn = '温馨提示：业主姓名不能输入特殊符号'
}else if(!this.username){
this.messageWarn = '温馨提示：请输入您的真实姓名'
}else if(!this.houseBind){
console.log("xxxxxxxxxxxxxxxxxx"+this.houseBind);
this.messageWarn = '温馨提示：房屋与业主不匹配'
}else if(!this.relation[0]){
this.messageWarn = '温馨提示：请选择与业主的关系'
}else{

this.beforXy("#绑定房间信息#users/register/"+ this.$router.history.current.query.openid + '/' + this.$router.history.current.query.phone + '/' + this.house[2] + '/' + this.username + '/' + this.$router.history.current.query.phone + '/' + this.relationlistid[this.getIndex(this.relationlist[0],this.relation[0])] + '/' + this.districtlistid[this.getIndex(this.districtlist[0],this.district[0])] + '/' + this.$router.history.current.query.IsDefault);
this.username = this.username.replace(/(^\s*)|(\s*$)/g,"");
console.log(global.host + 'users/register?openid='+ this.$router.history.current.query.openid + '&phone=' + this.$router.history.current.query.phone + '&roomNumber=' + this.house[2] + '&registrantName=' + this.username + '&phoneNumber=' + this.$router.history.current.query.phone + '&relationShip=' + this.relationlistid[this.getIndex(this.relationlist[0],this.relation[0])] + '&comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0],this.district[0])] + '&IsDefault=' + this.$router.history.current.query.IsDefault);
this.$http.get(global.host + 'users/register?openid='+ this.$router.history.current.query.openid + '&phone=' + this.$router.history.current.query.phone + '&roomNumber=' + this.house[2] + '&registrantName=' + this.username + '&phoneNumber=' + this.$router.history.current.query.phone + '&relationShip=' + this.relationlistid[this.getIndex(this.relationlist[0],this.relation[0])] + '&comnCode=' + this.districtlistid[this.getIndex(this.districtlist[0],this.district[0])] + '&IsDefault=' + this.$router.history.current.query.IsDefault).then(function(res){
console.log(res)
if(res.body.result == 'success'){
this.alertTitle ='恭喜'
this.alertContent = '房屋绑定成功'
this.showAlert = true;
}else{
this.alertTitle ='抱歉'
this.alertContent = res.body.message;
this.showAlert = true;
}
},function(err){
console.log(err);
})
}
},
/*房间检测*/
updateVal(){
this.houseBind = false;
},
checkBind(){
this.houseBind = false;
if(!this.district[0]){
this.messageWarn = '请选择小区'
}else if(!this.house[0] && !this.house[1] && !this.house[2]){
this.messageWarn = '请选择房间'
}else if(!this.owner){
this.messageWarn = '请输入业主姓名'
}else{

this.beforXy("#验证业主是否匹配#users/checkUserIsExistByUtil?comnCode="+ this.districtlistid[this.getIndex(this.districtlist[0],this.district[0])] + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0],this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' +  this.house[2] + '&userName=' + encodeURIComponent(this.owner));
this.owner = this.owner.replace(/(^\s*)|(\s*$)/g,"");
this.$http.get(global.host + '/users/checkUserIsExistByUtil?comnCode='+ this.districtlistid[this.getIndex(this.districtlist[0],this.district[0])] + '&buildCode=' + this.houselistid[this.getIndex(this.houselist[0],this.house[0])] + '&fool=' + this.house[1] + '&houseCode=' +  this.house[2] + '&userName=' + encodeURIComponent(this.owner),).then(function(res){
if(res.body.success){
/*改变样式 存在*/
this.houseBind = true;
}else{
/*改变样式 不存在*/
this.alertTitle ='温馨提示'
this.alertContent = '请输入物业登记的业主姓名'
this.houseBind = false;
this.showAlert = true;
setTimeout(function(){this.showAlert = false;},2000)
}
},function(err){
console.log(err);
})
}
},
/*选择小区获取楼的数据*/
selectComnBuildList(value){
console.log("######################");
this.houselist = [];
this.buildid = [];
this.houselistid = [];
this.buildList = [];
/*获取小区中的楼号信息*/
this.$http.get(global.host + 'building/getList?comnCode='+ this.districtlistid[this.getIndex(this.districtlist[0],value[0])]).then(function(resbuild){
if(resbuild.body.result){
let arr1 = [];
let databuild = resbuild.body.result;
this.buildList =  resbuild.body.result;

for(let j = 0 ;j < databuild.length ; j++){
arr1.push(databuild[j].buildName + (databuild[j].unitName ? databuild[j].unitName : ''))
if(databuild[j].unitid){
this.houselistid.push(databuild[j].buildid)
this.buildid.push(databuild[j].unitid)
}else{
this.houselistid.push(databuild[j].buildid)
}
}

this.houselist.push(arr1);
let arr2 = [];
console.log(databuild[0].height);
for(let i = 0 ;i < databuild[0].height.length; i++){
arr2.push(databuild[0].height[i]);
}
this.houselist.push(arr2);
/*获取房间的信息*/
this.$http.get(global.host + 'house/getList?comnCode='+ this.districtlistid[this.getIndex(this.districtlist[0],value[0])] + '&buildCode=' + this.houselistid[0] + '&fool=1F' + '&unit=' + (this.buildid[0] ? this.buildid[0] :'')).then(function(reshouse){
if(reshouse.body.result){
let datahouse = reshouse.body.result;
let arr3 = [];
for(let k= 0 ;k < datahouse.length ; k++){
arr3.push(datahouse[k].hsNo)
}
this.houselist.push(arr3)
}
},function(errhouse){
console.log(errhouse)
})
}
},function(errbuild){
console.log(errbuild)
})
},

/*选择小区*/
selectDistrict(){
this.houselist = [];
this.buildid = [];
this.houselistid = [];
/*获取小区中的楼号信息*/
this.$http.get(global.host + 'building/getList?comnCode='+ this.districtlistid[this.getIndex(this.districtlist[0],this.district[0])]).then(function(resbuild){
if(resbuild.body.result){
let arr1 = [];
let databuild = resbuild.body.result
this.buildList =  resbuild.body.result;
for(let j = 0 ;j < databuild.length ; j++){
arr1.push(databuild[j].buildName + (databuild[j].unitName ? databuild[j].unitName : ''))
if(databuild[j].unitid){
this.houselistid.push(databuild[j].buildid)
this.buildid.push(databuild[j].unitid)
}else{
this.houselistid.push(databuild[j].buildid)
}
}
this.houselist.push(arr1);
let arr2 = [];
for(let i = 0 ;i < databuild[0].height.length; i++){
arr2.push(databuild[0].height[i]);
}
this.houselist.push(arr2);
/*获取房间的信息*/
this.$http.get(global.host + 'house/getList?comnCode='+ this.districtlistid[this.getIndex(this.districtlist[0],this.district[0])] + '&buildCode=' + this.houselistid[0] + '&fool=1F' + '&unit=' + (this.buildid[0] ? this.buildid[0] :'')).then(function(reshouse){
if(reshouse.body.result){
let datahouse = reshouse.body.result;
let arr3 = [];
for(let k= 0 ;k < datahouse.length ; k++){
arr3.push(datahouse[k].hsNo)
}
this.houselist.push(arr3)
}
},function(errhouse){
console.log(errhouse)
})
}
},function(errbuild){
console.log(errbuild)
})
},
/*联调函数*/
selectValue(value){
for(let i = 0 ; i < 3 ; i++){
if(value[i] != this.house[i]){
switch(i){
case 0:
this.house[0] = value[0];
this.getStoreyInfo(value[0]);
this.$nextTick(() => {
PopupPicker.props.data = this.houselist;
})
return;
case 1:
this.house[0] = value[0];
this.house[1] = value[1];
this.getHouseInfo(value[0],this.district[0],value[1]);
this.$nextTick(() => {
PopupPicker.props.data = this.houselist;
})
return;
case 2:
this.house[0] = value[0];
this.house[1] = value[1];
this.house[2] = value[2];
return;
}
}
}
},
/*选择楼号获取楼层高度*/
getStoreyInfo(storeyname){
/*this.$http.get(global.host + 'building/getList?comnCode='+ this.districtlistid[this.getIndex(this.districtlist[0],this.district[0])]).then(function(res){
let storeyid = this.getIndex(this.houselist[0],storeyname);
let commid = this.getIndex(this.districtlist[0],this.district[0])
if(res.body.result) {*/
let storeyid = this.getIndex(this.houselist[0],storeyname);
let commid = this.getIndex(this.districtlist[0],this.district[0]);
let size = this.houselist[1].length;
let size1 = this.houselist[2].length;

for (var j = 1; j < size; j++) {
this.houselist[1].pop();
}
for (var j = 1; j < size1; j++) {
this.houselist[2].pop();
}
let databuild = this.buildList[this.getIndex(this.houselist[0],storeyname)].height;
for (let i = 0; i < databuild.length; i++) {
this.houselist[1].push(databuild[i])
}
if(this.houselist[1].length > 1){
this.houselist[1].shift();
}else{
this.houselist[1].push(' ');
this.houselist[1].shift();
}
this.$http.get(global.host + 'house/getList?comnCode=' + this.districtlistid[commid] + '&buildCode=' + this.houselistid[storeyid] + '&fool=' + (this.house[1] ? this.house[1] : 1) + '&unit=' + (this.buildid[storeyid] ? this.buildid[storeyid] : ''),).then(function (res) {
if (res.body.result) {
let data = res.body.result;
let mis = [];
/*let size = this.houselist[2].length;
for(let a = 1; a< size; a++){
this.houselist[2].pop();
}*/
for (let k = 0; k < data.length; k++) {
this.houselist[2].push(data[k].hsNo);
}
if(this.houselist[2].length > 1){
this.houselist[2].shift();
}







} else {
this.houselist[2].push('');
let houseNum = this.houselist[2].length - 1;
for (let i = 0; i < houseNum; i++) {
this.houselist[2].pop();
}
}

}, function (err) {
console.log(err)
})
/* }
},function(err){
console.log(err)
});*/
},
/*选择楼层高度获取房间号*/
getHouseInfo(storeyname,buildname,floor){
let storeyid = this.getIndex(this.houselist[0],storeyname);
let commid = this.getIndex(this.districtlist[0],buildname)
let houseInfo = new Array();
this.$http.get(global.host + 'house/getList?comnCode='+ this.districtlistid[commid] + '&buildCode=' + this.houselistid[storeyid] + '&fool=' + floor+ '&unit=' + (this.buildid[storeyid] ? this.buildid[storeyid] :'') ,).then(function(res){
console.log(res)
if(res.body.result){
let size = this.houselist[2].length;
for(var j = 1 ; j < size ; j++){
this.houselist[2].pop();
}
let data = res.body.result;
for(let k= 0 ;k < data.length ; k++){
this.houselist[2].push(data[k].hsNo)
}
this.houselist[2].shift();
}else{
/*清空房间信息 追加一个空的信息 防止数据为空*/
let size = this.houselist[2].length;
for(var j = 1 ; j < size ; j++){
this.houselist[2].pop();
}
this.houselist[2].push('')
this.houselist[2].shift()
}
},function(err){
console.log(err)
})
},
/*获取索引值*/
getIndex(arr,feild){
for(let i = 0 ; i < arr.length; i++){
if(feild == arr[i]){
return i;
}else{
continue
}
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/userComponents/houseBind.vue